import bundle from '@crosure/tenant'
import {
	assertValidBundle,
	mergeWithDefaults,
	type ResolvedTenantBundle,
} from '@crosure/tenant-runtime'

const resolvedTenant = mergeWithDefaults(bundle)
assertValidBundle(resolvedTenant)

export const tenant: ResolvedTenantBundle = resolvedTenant
export const tenantCode = tenant.meta.code

export default tenant
